import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src3165077977/src/codestar-connections.eu-west-1.amazonaws.com/git-http/471112859602/eu-west-1/ee15b64b-8c7d-4ab7-b668-2c0ec41dbd39/studyportals/OmniSearch/src/app/layouts/default.vue").then(m => m.default || m))
}